import * as RadixCheckbox from '@radix-ui/react-checkbox';
import { Check, Minus } from 'lucide-react';
import { cn } from '@/shared/lib/cn';
import type { ComponentProps } from 'react';

export function Checkbox({ className, ...props }: ComponentProps<typeof RadixCheckbox.Root>) {
  return (
    <RadixCheckbox.Root
      className={cn(
        'border-border-strong bg-bg-elevated data-[state=checked]:border-brand-600 data-[state=checked]:bg-brand-600 data-[state=indeterminate]:border-brand-600 data-[state=indeterminate]:bg-brand-600 data-[state=indeterminate]:text-white focus-visible:ring-ring flex h-4 w-4 shrink-0 items-center justify-center rounded border focus-visible:ring-2 focus-visible:outline-none data-[state=checked]:text-white',
        className,
      )}
      {...props}
    >
      {/* Kısmi seçim (ağaçta üst düğüm, #467): tik yerine çizgi. */}
      <RadixCheckbox.Indicator>
        {props.checked === 'indeterminate' ? <Minus className="h-3 w-3" /> : <Check className="h-3 w-3" />}
      </RadixCheckbox.Indicator>
    </RadixCheckbox.Root>
  );
}
